module.exports = __webpack_public_path__ + "img/why-keyapl-2.e3aed2fd.png";